import { Request } from "./HttpService";

export const ApplicationDetailService = {
  Create(applicationDetails) {
    return Request("vitae/applicationDetail", "POST", applicationDetails);
  }
};
